import React from "react";

import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import { Stack, Typography } from "@mui/material";

interface IProps {
  text?: string;
  icon?: React.ReactNode;
}

export const PopupEmptyState: React.FC<IProps> = ({
  text = "No data available yet.",
  icon = <InboxOutlinedIcon sx={{ fontSize: "40px", color: "#BAC7CE" }} />
}) => (
  <Stack alignItems="center" justifyContent="center" sx={{ py: "24px" }} gap="12px">
    {icon}
    <Typography sx={{ fontSize: "13px", color: "#92A7BC", textAlign: "center", maxWidth: "320px" }}>{text}</Typography>
  </Stack>
);
